// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"tornado"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M14 21L9 21M12 18H6M14 15L7 15M18 12L9 12M20 9H7M18 6L5.52778 6C4.68401 6 4 5.32843 4 4.5C4 3.67157 4.68401 3 5.52778 3L7 3","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const TornadoIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'tornado',
    ref,
    icon: element,
  },
));

TornadoIcon.displayName = 'TornadoIcon';

export default TornadoIcon;
